import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Vehicles from './pages/Vehicles';
import VehicleDetail from './pages/VehicleDetail';
import Challans from './pages/Challans';
import Import from './pages/Import';
import Alerts from './pages/Alerts';
import Drivers from './pages/Drivers';

function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/vehicles" element={<Vehicles />} />
        <Route path="/vehicles/:vehicleNumber" element={<VehicleDetail />} />
        <Route path="/challans" element={<Challans />} />
        <Route path="/import" element={<Import />} />
        <Route path="/alerts" element={<Alerts />} />
              <Route path="/drivers" element={<Drivers />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}

export default App;
